<!-- TODO write docs about it -->
<template>
  <div class="checkbox-like-radio">
    <q-checkbox
      :value="checkbox1"
      :false-value="falseValue"
      :true-value="checkbox1TrueValue"
      :label="checkbox1Label"
      :indeterminate-value="indeterminateValue"
      @input="toggleCheckbox1"
    />

    <q-checkbox
      :value="checkbox2"
      :false-value="falseValue"
      :true-value="checkbox2TrueValue"
      :label="checkbox2Label"
      :indeterminate-value="indeterminateValue"
      @input="toggleCheckbox2"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: [Boolean, String],
    checkbox1Label: String,
    checkbox2Label: String,
    checkbox1TrueValue: {
      type: [Boolean, String],
      default: true
    },
    checkbox2TrueValue: {
      type: [Boolean, String],
      default: false
    },
    falseValue: {
      type: [Boolean, String],
      default: null
    },
    indeterminateValue: {
      type: String,
      default: 'something not related' // to avoid clashing with false value
    }
  },

  data() {
    return {
      checkbox1: this.value,
      checkbox2: this.value
    }
  },

  methods: {
    toggleCheckbox1(val) {
      this.checkbox2 = this.falseValue
      this.checkbox1 = val
      this.$emit('input', val)
    },

    toggleCheckbox2(val) {
      this.checkbox1 = this.falseValue
      this.checkbox2 = val
      this.$emit('input', val)
    }
  }
}
</script>
